<template>
    <div id="user-box">
        <div class="container-fluid card-info mb-3" v-bind:class="{suspended: user.attributes['is-enabled'] === false, 'current-user': user.id === authUser.id}">
            <div class="row align-items-center" v-if="user">
                <div class="avatar img-box col-auto text-center p-2">
                    <router-link :to="{ name: '' }">
                        <label class="label-avatar" @click="openEditModal()">
                            <model-short-name v-if="user.attributes['profile-picture'] === null" :model="user"></model-short-name>
                            <img class="user-img" :src="`${user.attributes['profile-picture']}?${timeStamp}`" alt="" v-else>
                        </label>
                    </router-link>
                </div>
                <div class="col user-fields">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-2 text-left user-info">
                            <p class="m-0">{{user.attributes['first-name']}}</p>
                            <small class="text-primary">{{ $t('first-name') }}</small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-2 text-left user-info">
                            <p class="m-0">{{user.attributes['last-name']}}</p>
                            <small class="text-primary">{{ $t('last-name') }}</small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 text-left user-info">
                            <p class="m-0">{{user.attributes['email']}}</p>
                            <small class="text-primary">{{ $t('email') }}</small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-2 text-left user-info-important">
                            <p class="m-0" v-if="user.attributes['is-admin'] === true">{{ $t('admin') }}</p>
                            <p class="m-0" v-else>{{ $t('user') }}</p>
                            <small class="text-primary">{{ $t('role') }}</small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg text-left user-info-important">
                            <p class="m-0" v-if="user.attributes['is-invited'] === true">{{ $t('invited') }}</p>
                            <p class="m-0" v-else-if="user.attributes['is-enabled'] === true">{{ $t('active') }}</p>
                            <p class="m-0" v-else>{{ $t('suspended') }}</p>
                            <small class="text-primary">{{ $t('status') }}</small>
                        </div>
                        <div class="col-auto text-left user-info-important d-flex align-items-center">
                            <span
                                class="badge-2fa"
                                :class="user.attributes['is-two-factor-enabled'] ? 'is-on' : 'is-off'"
                                v-b-tooltip.hover.bottom="user.attributes['is-two-factor-enabled'] ? $t('2fa-enabled') : $t('2fa-disabled')"
                            >
                                <font-awesome-icon :icon="['fas', user.attributes['is-two-factor-enabled'] ? 'check' : 'exclamation-triangle']" />
                                2FA
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-auto user-actions">
                    <a class="header-icon user-icon " href="#" role="button" id="userManagment" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" v-if="user.id !== authUser.id">
                        <font-awesome-icon class="text-primary edit-btn ellipsis" :icon="['fas', 'ellipsis-v']" />
                    </a>
                    <div class="dropdown-menu managment-menu" aria-labelledby="userManagment" v-if="user.id !== authUser.id">
                        <button
                            type="button"
                            class="dropdown-item"
                            @click="openEditModal()">
                            {{ $t('edit') }}
                        </button>
                        <button
                            type="button"
                            class="dropdown-item"
                            :disabled="user.attributes['is-invited']"
                            @click="changeStatus()">
                            {{ user.attributes['is-enabled'] ? $t('suspend') : $t('activate') }}
                        </button>
                        <button
                            type="button"
                            class="dropdown-item"
                            :disabled="!authUser.attributes['is-super-admin'] && !authUser.attributes['is-admin']"
                            @click="confirmAlert()">
                            {{ $t('delete') }}
                        </button>
                    </div>
                </div>
                <base-modal
                    :id="modalId"
                    :title="$t('edit-user')"
                    :ok-disabled="disabled"
                    :busy="loading"
                    @ok="updateUserinformations(editableAttributes)"
                    @hidden="cancelChanges()"
                >
                    <form>
                        <div class="form-group text-left">
                            <label class="col-form-label">{{ $t('email-adress') }}</label>
                            <input type="email" class="form-control" v-model="user.attributes['email']" disabled>
                        </div>
                        <div class="form-group text-left">
                            <label class="col-form-label">{{ $t('first-name') }} <strong class="obligatory">*</strong></label>
                            <input
                                name="first-name"
                                type="text"
                                class="form-control"
                                v-model="editableAttributes['first-name']"
                                v-validate="'required'"
                                :class="{ 'is-invalid': submitted && errors.has('first-name') }"
                                :data-vv-as="$t('first-name')"
                                @change="disabled = false"
                            >
                            <div class="invalid-feedback" v-if="submitted">
                                {{ errors.first('first-name') }}
                            </div>
                        </div>
                        <div class="form-group text-left">
                            <label class="col-form-label">{{ $t('last-name') }} <strong class="obligatory">*</strong></label>
                            <input
                                name="last-name"
                                type="text"
                                class="form-control"
                                v-model="editableAttributes['last-name']"
                                v-validate="'required'"
                                :class="{ 'is-invalid': submitted && errors.has('last-name') }"
                                :data-vv-as="$t('last-name')"
                                @change="disabled = false"
                            >
                            <div class="invalid-feedback" v-if="submitted">
                                {{ errors.first('last-name') }}
                            </div>
                        </div>
                        <div class="form-group text-left">
                            <label>{{ $t('role') }}</label>
                            <select
                                class="form-control"
                                v-model="editableAttributes['is-admin']"
                                @change="disabled = false"
                                :disabled="this.user.attributes['is-saml']"
                            >
                                <option :value="true">{{ $t('admin') }}</option>
                                <option :value="false">{{ $t('user') }}</option>
                            </select>
                        </div>
                    </form>
                </base-modal>
            </div>
            <span class="current-user-sticker" v-if="user.id === authUser.id">{{ $t('you') }}</span>
        </div>
    </div>
</template>
<script>

// Internal components
import BaseModal      from '@/core/components/BaseModal.vue';
import ModelShortName from '@/core/components/ModelShortName.vue';

// Internal services js
import Alert from '@/helpers/Alert.js';

// Import external libraries
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        BaseModal,
        ModelShortName
    },

    data () {
        return {
            submitted:          false,
            loading:            false,
            editableAttributes: {},
            timeStamp:          0,
            disabled:           true
        };
    },

    props: [
        'user'
    ],

    computed: {
        ...mapState('core/tenants', [
            'selectedTenant'
        ]),

        ...mapState('core/auth', {
            'authUser': 'user'
        }),

        /**
         * The id of the edit user modal
         *
         * @return {string}
         */
        modalId () {
            return `edit-modal-user-${this.user.id}`;
        }
    },

    /**
     * Component created handler
     */
    created () {
        this.editableAttributes = {
            'first-name': this.user.attributes['first-name'],
            'last-name':  this.user.attributes['last-name'],
            'is-admin':   this.user.attributes['is-admin']
        };

        // Generate a time stamp that will be added to avatar urls to make sure we are not loading the avatar in the browser's cache
        this.timeStamp = Date.now();
    },

    methods: {
        ...mapActions('core/users', [
            'patch'
        ]),
        ...mapActions('core/tenant-users', {
            deleteTenantUser: 'delete'
        }),

        /**
         * Show confirm dialog alert
         */
        confirmAlert () {
            const relationshipId = `${this.selectedTenant.id}_${this.user.id}`;

            this.$dialog.confirm({
                subject:     this.$t('confirm-user-delete'),
                text:        this.user.attributes.email,
                centerText:  true,
                confirmText: this.$t('delete'),
                danger:      true,
                onConfirm:   () => this.deleteTenantUser({
                    user: this.user,
                    relationshipId
                })
            })
                .then((confirmed) => {
                    if (confirmed) {
                        Alert.success(this.$i18n.t('user-deleted'));
                    }
                })
                .catch(() => {
                    Alert.fail(this.$i18n.t('default-error'));
                });
        },

        /**
         * Save the new user informations
         *
         * @param    {object}    editableAttributes    the user's new informaions
         */
        updateUserinformations (editableAttributes) {
            this.submitted = true;
            this.$validator.validate().then(valid => {
                if (!valid) {
                    return;
                }

                // Start loading and disable button
                this.loading  = true;
                this.disabled = true;

                // Keep the used SAML role for the saml user
                if (this.user.attributes['is-saml']) {
                    editableAttributes['is-admin'] = this.user.attributes['is-admin'];
                }

                // Send the new informations to the api
                this.patch({
                    id:         this.user.id,
                    attributes: editableAttributes
                })
                    .then(() => {
                        this.loading   = false;
                        this.submitted = false;

                        // Show the success alert and close the model
                        Alert.success(this.$i18n.t('information-updated'));
                        this.$bvModal.hide(this.modalId);
                    });
            });
        },

        /**
         * Open the edit user modal
         */
        openEditModal () {
            if (this.user.id !== this.authUser.id) {
                this.$bvModal.show(this.modalId);
            }
        },

        /**
         * Cancel all changes
         */
        cancelChanges () {
            this.editableAttributes['first-name'] = this.user.attributes['first-name'];
            this.editableAttributes['last-name']  = this.user.attributes['last-name'];
            this.editableAttributes['is-admin']   = this.user.attributes['is-admin'];

            this.submitted = false;
        },

        /**
         * Change the status of user
         */
        changeStatus () {
            // Reverse the current status and Send it to the api
            this.patch({
                id:         this.user.id,
                attributes: {
                    'is-enabled': !this.user.attributes['is-enabled']
                }
            });
        }
    }
};
</script>
